import pako from "pako";

// Слой сокет-соединений клиента.
//
// Обычно соединение одно: клиент подключается к ноде, на которой живёт аккаунт пользователя
// (первичное соединение). Но у админов есть ещё и вторичные соединения - ко всем остальным нодам
// кластера: так админ видит списки со всех нод (Documents/Cluster.txt). Поэтому соединения хранятся
// в реестре по номеру ноды, а данные с сервера помечаются номером ноды-источника.
const Socket = {

	Name: "Service Socket",

	init() {

		this.socketOnCloseRepeat = 5000;

		// Соединения с нодами кластера: serverId -> {serverId, url, socket, connected, reconnectTimeout}
		this.Sockets = {};

		// Номер ноды, к которой подключён клиент (нода аккаунта). До метаданных он неизвестен и равен нулю:
		// когда метаданные придут, соединение переезжает из временного ключа 0 в ключ с настоящим номером
		this.PrimaryServerId = 0;

		// Нода, на которую по умолчанию уходят запросы клиента: это нода открытого паблишера.
		// Админ может работать с паблишером любой ноды кластера, и его данные нужно запрашивать у неё
		this.DefaultServerId = 0;

	},

	// Первичное соединение помечаем нулём: пока метаданные не пришли, номер ноды аккаунта неизвестен
	getPrimaryServerId() {

		return this.PrimaryServerId || 0;

	},

	// Нода, на которую уходят запросы клиента без явного указания ноды
	getDefaultServerId() {

		return this.DefaultServerId || this.getPrimaryServerId();

	},

	// Нода выбранного паблишера: её выставляет сервис Publisher при выборе паблишера
	setDefaultServerId(serverId) {

		this.DefaultServerId = parseInt(serverId, 10) || 0;

	},

	// Номер ноды первичного соединения. Вызывается из Metadata, когда приходят метаданные,
	// и из сервиса Server при подключении (номер ноды аккаунта уже известен из Auth)
	setPrimaryServerId(serverId) {

		serverId = parseInt(serverId, 10) || 0;

		if (this.PrimaryServerId === serverId) return;

		// Вторичное соединение с этой нодой уже есть - первичное ему не нужно
		if (serverId && this.Sockets[serverId] && this.Sockets[serverId].connected) return;

		let connection = this.Sockets[0];

		if (connection) {

			delete this.Sockets[0];

			connection.serverId = serverId;

			this.Sockets[serverId] = connection;

		}

		this.PrimaryServerId = serverId;

	},

	getConnection(serverId) {

		return this.Sockets[serverId || this.getDefaultServerId()] || null;

	},

	// Есть ли активное соединение с нодой (по умолчанию - с первичной)
	isConnected(serverId) {

		let connection = this.getConnection(serverId);

		return !!(connection && connection.connected);

	},

	connectSocket(url, serverId) {

		serverId = serverId || this.getPrimaryServerId();

		let connection = this.Sockets[serverId] || (this.Sockets[serverId] = {serverId, url, socket: null, connected: false, reconnectTimeout: null});

		connection.serverId = serverId;
		connection.url = url;

		if (connection.socket && connection.socket.readyState !== WebSocket.CLOSED) return;

		clearTimeout(connection.reconnectTimeout);

		let socket = connection.socket = new WebSocket(url);

		socket.onopen = _.bind(function() {

			console.log(`Socket connection established (server ${connection.serverId}). Remote address: ` + url);

			connection.connected = true;

			Broadcast.call('Socket Connection Established', [connection.serverId]);

		}, this);

		socket.onclose = _.bind(function() {

			if (this.socketOnCloseRepeat) {

				let timeout = this.socketOnCloseRepeat < 1000 ? 1000 : this.socketOnCloseRepeat;

				console.log(`Socket connection closed (server ${connection.serverId}). Remote address: ` + url);

				connection.reconnectTimeout = setTimeout(_.bind(function() {

					this.connectSocket(connection.url, connection.serverId);

				}, this), timeout);

			}

			connection.connected = false;

			Broadcast.call('Socket Connection Closed', [connection.serverId]);

		}, this);

		socket.onmessage = function(event) {

			let data = JSON.parse(event.data);
			if (!data) throw new Error('Socket server data error:', event.data);

			if (data.pako) data = JSON.parse(pako.inflate(data.pako, { to: 'string' }));

			// Номер ноды передаём дальше: сервисы по нему понимают, чьи это данные
			Broadcast.call("Server Data Received", [data, event.data.length, connection.serverId]);

			if (data.Broadcast) Broadcast.call(data.Broadcast.eventName, data.Broadcast.params || []);

		};

		socket.onerror = function (error) {};

	},

	disconnectSocket(next, serverId) {

		serverId = serverId || this.getPrimaryServerId();

		let connection = this.getConnection(serverId);

		clearTimeout(connection?.reconnectTimeout);

		if (connection && connection.connected) {

			if (connection.socket) connection.socket.close();

			connection.connected = false;

			let eventKey = Date.now() + '';

			Broadcast.on('Socket Connection Closed', function () {

				Broadcast.off('Socket Connection Closed', eventKey);

				if (next) next();

			}, eventKey);

		} else {

			if (next) next();

		}

	},

	sendToSocket(object, serverId) {

		let connection = this.getConnection(serverId);

		if (connection && connection.connected) {

			if (_.isString(object)) {

				let o = {};

				o[object] = true;

				object = o;

			}

			// Номер ноды в логе: клиент подключён сразу к нескольким нодам кластера
			console.info(`%c>>> SEND TO SERVER ${connection.serverId} >>`, 'color: #e79122', object);

			connection.socket.send(JSON.stringify(object));

		} else {

			console.warn(`Socket ${serverId || this.getDefaultServerId()} not connected in .sendToSocket();`, object);

		}

	},

	// По умолчанию запрос уходит на ноду аккаунта (первичное соединение)
	sendToServer(object, serverId) {

		return this.sendToSocket(object, serverId);

	},

	reconnectSocket(serverId) {

		serverId = serverId || this.getPrimaryServerId();

		let connection = this.getConnection(serverId);

		if (connection && connection.connected) connection.socket.close();

		Broadcast.on('Socket Connection Closed', function() {

			this.connectSocket(connection?.url, serverId);

			Broadcast.off('Socket Connection Closed', this);

		}, this);

	}

};

export default Socket;
